import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

export const Academic = () => {
    const navigate = useNavigate();
    useEffect(() => {
        AOS.init();
    }, []);

    return (
        <>
            {/* SEO Tags */}
            <div>
                <Helmet>
                    <title>Academics | McGAN'S Ooty School of Architecture</title>
                    <meta name="description" content="Explore B.Arch and M.Arch programs at McGAN'S Ooty School of Architecture. Learn about our undergraduate and postgraduate architecture courses, eligibility, and how to apply." />
                </Helmet>
                <h1 style={{ display: "none" }}>Academics at McGAN'S Ooty School of Architecture</h1>
            </div>
            {/* Page Banner */}
            {/* <div className="page-banner-area bg-1">
                <div className="container">
                    <div className="page-banner-content">
                        <h3 className="BannerHeader">Academics</h3>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li className="navspace">Academics</li>
                        </ul>
                    </div>
                </div>
            </div> */}
            {/* End Page Banner */}

            {/* Academics Section */}
            <div className="academics-details-area pt-100 pb-70">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 col-md-6 mb-4" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200" data-aos-once="true">
                            <div className="single-academics-card text-center p-4 shadow rounded">
                                <div className="academic-top-content mb-3">
                                    <i className="flaticon-graduation" style={{ fontSize: 40, color: '#001f6d' }}></i>
                                    <h3 className="mt-2">B.Arch</h3>
                                </div>
                                <p className="text-justify mb-4">
                                    Bachelor of Architecture (B.Arch) is a comprehensive program fostering creativity, innovation, and leadership, blending design with technology, theory, and history.
                                </p>
                                <button className="default-btn btn btn-block mb-2" onClick={() => navigate("/barch-application")}>Apply for B.Arch</button>

                            </div>
                        </div>
                        <div className="col-lg-5 col-md-6 mb-4" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="400" data-aos-once="true">
                            <div className="single-academics-card text-center p-4 shadow rounded">
                                <div className="academic-top-content mb-3">
                                    <i className="flaticon-college-graduation" style={{ fontSize: 40, color: '#001f6d' }}></i>
                                    <h3 className="mt-2">M.Arch</h3>
                                </div>
                                <p className="text-justify mb-4">
                                    Master of Architecture (M.Arch) in Environmental Architecture focuses on sustainable and green architecture, inspiring future environmental architects.
                                </p>
                                <button className="default-btn btn btn-block mb-2" onClick={() => navigate("/march-application")}>Apply for M.Arch</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

